import { render, staticRenderFns } from "./TutorialScreen.vue?vue&type=template&id=445f9578&scoped=true"
import script from "./TutorialScreen.vue?vue&type=script&lang=js"
export * from "./TutorialScreen.vue?vue&type=script&lang=js"
import style0 from "./TutorialScreen.vue?vue&type=style&index=0&id=445f9578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f9578",
  null
  
)

export default component.exports